import React from 'react';
import icArrowDisabled1 from 'Assets/img/ic_arrow_b2_17.png';
import icArrowDisabled2 from 'Assets/img/ic_arrow_b2_17@2x.png';
import icArrowDisabled3 from 'Assets/img/ic_arrow_b2_17@3x.png';
import icArrow1 from 'Assets/img/ic_arrow_666_17.png';
import icArrow2 from 'Assets/img/ic_arrow_666_17@2x.png';
import icArrow3 from 'Assets/img/ic_arrow_666_17@3x.png';
import icDoubleArrow1 from 'Assets/img/ic_double_arrow_666_17.png';
import icDoubleArrow2 from 'Assets/img/ic_double_arrow_666_17@2x.png';
import icDoubleArrow3 from 'Assets/img/ic_double_arrow_666_17@3x.png';
import { getImageSet } from 'Util/DataUtils';

const icArrowDisabled = getImageSet([icArrowDisabled1, icArrowDisabled2, icArrowDisabled3]);
const icArrow = getImageSet([icArrow1, icArrow2, icArrow3]);
const icDoubleArrow = getImageSet([icDoubleArrow1, icDoubleArrow2, icDoubleArrow3]);

const Pagination = ({ isEmpty, page, setPage, totalPage }) => {
  if (isEmpty) return <></>;
  return (
    <div className={`basic-pagination `}>
      {totalPage > 5 && (
        <div className="basic-pagination-item no-drag" onClick={() => setPage(1)}>
          <img {...icDoubleArrow} alt="icDoubleArrow" />
        </div>
      )}
      <div
        className="basic-pagination-item no-drag"
        onClick={() => {
          if (page > 1) setPage(page - 1);
        }}
      >
        {totalPage > 1 ? <img {...icArrow} alt="icArrow" /> : <img {...icArrowDisabled} alt="icArrowDisabled" />}
      </div>
      {Array.from({ length: totalPage }, (_, index) => {
        const pageNumber = index + 1;
        let startPage = Math.floor((page - 1) / 5) * 5 + 1;
        let endPage = startPage + 4;

        if (endPage > totalPage) {
          endPage = totalPage;
        }

        if (pageNumber >= startPage && pageNumber <= endPage) {
          return (
            <div key={index} className={`basic-pagination-item no-drag ${pageNumber === page && 'selected'}`} onClick={() => setPage(pageNumber)}>
              {pageNumber}
            </div>
          );
        }
        return null;
      })}
      <div
        className="basic-pagination-item no-drag"
        onClick={() => {
          if (page < totalPage) setPage(page + 1);
        }}
      >
        {totalPage > 1 ? <img {...icArrow} alt="icArrow" style={{ transform: 'rotate(180deg)' }} /> : <img {...icArrowDisabled} alt="icArrowDisabled" style={{ transform: 'rotate(180deg)' }} />}
      </div>
      {totalPage > 5 && (
        <div className="basic-pagination-item no-drag" onClick={() => setPage(totalPage)}>
          <img {...icDoubleArrow} alt="icDoubleArrow" style={{ transform: 'rotate(180deg)' }} />
        </div>
      )}
    </div>
  );
};

export default Pagination;
